<header-ui
    [userDialogView]="userDialogView$ | async"
    [mobileNavigationMenu]="mobileNavigationMenu$ | async"
    [desktopNavigationMenu]="desktopNavigationMenu$ | async"
    (userDialogViewEvent)="userDialogView($event)"></header-ui>
<div #userDialogVCR></div>